import * as React from 'react'

import { useToggle } from '../hooks'

import { ToggleComponentsProps } from './types'

export const ToggleComponents: React.FC<ToggleComponentsProps> = (props) => {
    const {
        OtherComponent,
        InitialComponent,
        initialComponentProps,
        otherComponentProps
    } = props
    const initialToggleComponent =
        props.initialState !== undefined ? props.initialState : 'initial'

    const { active, toggle, toggleOn, toggleOff } = useToggle({
        initialState: initialToggleComponent !== 'initial'
    })

    return active ? (
        <OtherComponent
            toggle={toggle}
            toggleOff={toggleOff}
            {...otherComponentProps}
        />
    ) : (
        <InitialComponent
            toggle={toggle}
            toggleOn={toggleOn}
            {...initialComponentProps}
        />
    )
}
